import { sity, rubrics, gearboxes, engines } from 'shared/modules/subjectiveText/allText';
import { getSeoDataByParams } from 'shared/helpers/seoTextFinder';
import FIRST_RUBRICS_TYPES from 'shared/constants/json/firstSeoRubricsTypes.json';
import SECOND_RUBRICS_TYPES from 'shared/constants/json/secondSeoRubricsTypes.json';
import {
  replaceToUpperCase,
  replaceTransport,
  buildInGenitiveCityHeader,
  buildDriveValue,
  replaceToLowerCase,
} from 'shared/modules';

const defaultTranslate = v => v;
const valueVsTabOrEmpty = (val, t = defaultTranslate) => (val ? ` ${t(val)}` : '');

export const buildSearchAvtoSeoHeader = (data, t) => {
  const seoData = getSeoDataByParams(data, t);
  if (seoData && seoData.header) return seoData.header;

  const {
    make = '',
    model = '',
    location = '',
    generation = '',
    gearbox = '',
    engine = '',
    body = '',
    drive: driveSelected = '',
    isNew = false,
    year: yearSelected = '',
    makeTranslate = '',
    city = null,
  } = data;
  const locale = t('locale');

  const drive = buildDriveValue(t(driveSelected), t);
  const buOrUsed = body || generation || engine || gearbox ? 'б/у' : 'б у';
  const usedOrNew = !isNew ? buOrUsed : '';
  const year = yearSelected ? `${yearSelected} ${t('года')}` : '';

  const makeOrAuto = make || 'авто';
  const cityHeader = location && sity[location] ? location : '';
  const customGearbox = gearbox in gearboxes ? gearboxes[gearbox][locale].title : gearbox;
  const customEngineAlt = engine in engines ? engines[engine][locale].altTitle : engine;
  const customEngine = engine in engines ? engines[engine][locale].title : engine;

  const inCityHeader = cityHeader
    ? ` ${buildInGenitiveCityHeader(sity[cityHeader][locale].genitive)}`
    : (city &&
        city.title &&
        ` ${buildInGenitiveCityHeader(city[`${locale}_title`] || city.title)}`) ||
      '';

  if (locale === 'ru' && make && !model && !generation && !body && !engine && !drive && !gearbox) {
    return `${t('Продажа')}${valueVsTabOrEmpty(make)}${valueVsTabOrEmpty(
      usedOrNew,
      t,
    )}${valueVsTabOrEmpty(year)}${inCityHeader}`;
  }
  if (make && model && body && !generation && !engine && !drive) {
    return `${t('Продажа')}${valueVsTabOrEmpty(usedOrNew, t)}${valueVsTabOrEmpty(
      body,
      t,
    ).toLowerCase()}${valueVsTabOrEmpty(makeOrAuto)}${valueVsTabOrEmpty(model)}${valueVsTabOrEmpty(
      year,
    )}${inCityHeader}`;
  }
  if (make && model && (generation || gearbox) && !engine && !drive) {
    return `${t('Продажа')}${valueVsTabOrEmpty(usedOrNew, t)}${valueVsTabOrEmpty(
      makeOrAuto,
    )}${valueVsTabOrEmpty(model)}${valueVsTabOrEmpty(gearbox, t)}${valueVsTabOrEmpty(
      generation,
    )}${valueVsTabOrEmpty(year)}${inCityHeader}`;
  }
  if (make && model && (generation || gearbox) && drive && !engine) {
    return `${t('Продажа')}${valueVsTabOrEmpty(usedOrNew, t)}${valueVsTabOrEmpty(
      makeOrAuto,
    )}${valueVsTabOrEmpty(model)}${valueVsTabOrEmpty(generation)}${valueVsTabOrEmpty(
      gearbox,
      t,
    )}${valueVsTabOrEmpty(drive)}${valueVsTabOrEmpty(year)}${inCityHeader}`;
  }
  if (make && model && (generation || gearbox) && drive && engine) {
    return `${t('Продажа')}${valueVsTabOrEmpty(usedOrNew, t)}${valueVsTabOrEmpty(
      makeOrAuto,
    )}${valueVsTabOrEmpty(model)}${valueVsTabOrEmpty(engine, t)}${valueVsTabOrEmpty(
      gearbox,
      t,
    )}${valueVsTabOrEmpty(generation)}${valueVsTabOrEmpty(drive)}${valueVsTabOrEmpty(
      year,
    )}${inCityHeader}`;
  }
  if (!make && !model && !generation && !gearbox && !drive && engine) {
    return `${customEngineAlt}${valueVsTabOrEmpty(year)}${valueVsTabOrEmpty(
      usedOrNew,
      t,
    )}${inCityHeader}`;
  }
  if (make && !model && !generation && gearbox && !drive && !engine) {
    return `${makeTranslate || makeOrAuto}${valueVsTabOrEmpty(customGearbox)}${valueVsTabOrEmpty(
      year,
    )}${valueVsTabOrEmpty(usedOrNew, t)}${inCityHeader}`;
  }
  if (!make && !model && !generation && !gearbox && !drive && !engine && body) {
    return `${t('Авто')}${valueVsTabOrEmpty(body, t)}${valueVsTabOrEmpty(year)}${valueVsTabOrEmpty(
      usedOrNew,
      t,
    )}${inCityHeader}`;
  }
  if (make && !model && !generation && !gearbox && !drive && engine && !body) {
    return `${customEngine}${valueVsTabOrEmpty(makeTranslate || makeOrAuto)}${valueVsTabOrEmpty(
      year,
    )}${valueVsTabOrEmpty(usedOrNew, t)}${inCityHeader}`;
  }
  if (make && model && !generation && !gearbox && !drive && engine && !body) {
    return `${customEngine}${valueVsTabOrEmpty(makeTranslate || makeOrAuto)}${valueVsTabOrEmpty(
      model,
    )}${valueVsTabOrEmpty(year)}${valueVsTabOrEmpty(usedOrNew, t)}${inCityHeader}`;
  }
  if (!make && !model && !generation && gearbox && !drive && !engine && !body) {
    return `${t('Авто')}${valueVsTabOrEmpty(customGearbox)}${valueVsTabOrEmpty(
      year,
    )}${valueVsTabOrEmpty(usedOrNew, t)}${inCityHeader}`;
  }
  if (make && !model && !generation && !gearbox && !drive && !engine && body) {
    return `${makeTranslate || makeOrAuto}${valueVsTabOrEmpty(body, t)}${valueVsTabOrEmpty(
      year,
    )}${valueVsTabOrEmpty(usedOrNew, t)}${inCityHeader}`;
  }

  return `${t('Продажа')}${valueVsTabOrEmpty(usedOrNew, t)}${valueVsTabOrEmpty(
    makeOrAuto,
  )}${valueVsTabOrEmpty(model)}${valueVsTabOrEmpty(year)}${inCityHeader}`;
};

export const buildFirmsSeoHeader = (data, t) => {
  const { section, cityTitle, regLocation, location } = data;
  // if (section === 'СТО') {
  //   if (cityHeader) return `СТО в ${cityHeader}`;
  //   return `${t('Все')} СТО ${t('Украины')}`;
  // }
  // if (section && cityHeader) {
  //   return t('Каталог компаний {section} в {cityHeader}', {
  //     section,
  //     cityHeader,
  //   });
  // }
  // if (section) {
  //   return t('Каталог компаний {section} в Украине', { section });
  // }
  // if (cityHeader) {
  //   return `СТО в ${cityHeader}`;
  // }

  if (section === 'СТО' && cityTitle) {
    return t('Каталог СТО {cityTitle}', {
      section,
      cityTitle: t(regLocation) || t(location),
    });
  }

  if ((section === 'Авторазборка' || section === 'Авторозборка') && cityTitle) {
    return t('Авторазборка {cityTitle}. Каталог компаний по разбору авто на запчасти', {
      section,
      cityTitle: t(regLocation) || t(location),
    });
  }

  if ((section === 'Автовыкуп' || section === 'Автовикуп') && cityTitle) {
    return t('Автовыкуп {cityTitle}. Каталог компаний по выкупу авто', {
      section,
      cityTitle: t(regLocation) || t(location),
    });
  }

  if ((section === 'Запчасти' || section === 'Запчастини') && cityTitle) {
    return t('Дилеры автозапчастей {cityTitle}', {
      section,
      cityTitle: t(regLocation) || t(location),
    });
  }

  if ((section === 'Автотовары' || section === 'Автотовари') && cityTitle) {
    return t('Автотовары {cityTitle}. Каталог компаний по продаже товаров для авто', {
      section,
      cityTitle: t(regLocation) || t(location),
    });
  }

  if ((section === 'Сервисные центры' || section === 'Сервісні центри') && cityTitle) {
    return t('ТСЦ {cityTitle}', {
      section,
      cityTitle: t(regLocation) || t(location),
    });
  }

  if (cityTitle) {
    return t('Автомобильные компании, автосервисы {cityTitle}', {
      ...data,
      // section,
      cityTitle: t(regLocation) || t(location),
    });
  }

  return t('Каталог компаний Украины - Автомобильные организации');
};

export const buildDealersSeoHeader = (data, slug, t) => {
  const { make = '', model = '', location = '' } = data;
  const seoData = getSeoDataByParams(
    { ...data, transport: data.transport || slug },
    t,
    'avtosalony',
  );
  if (seoData && seoData.header) return seoData.header;

  const locale = t('locale');
  const isAvto = slug === 'avto';
  const isMoto = slug === 'mototsikl';
  const isBuss = slug === 'avtobus';
  const isTrucks = slug === 'gruzovye';

  const cityHeader = location && sity[location] ? location : '';
  const cityHeaderVsSpace = location && ` ${t(location)}`;
  const accusativeCityHeaderVsSpace = cityHeader ? ` ${sity[cityHeader][locale].accusative}` : '';
  const inGenitiveCityHeader = cityHeader
    ? ` ${buildInGenitiveCityHeader(sity[cityHeader][locale].genitive)}`
    : '';

  if (isAvto || isMoto) {
    const dealerType = isAvto ? 'Автосалоны' : 'Мотосалоны';

    if (!make && !model && inGenitiveCityHeader) {
      return `${t(dealerType)}${inGenitiveCityHeader}`;
    }
    if (make && !model && cityHeader) {
      return `${t(dealerType)} ${make} ${t(cityHeader)}`;
    }
    if (make && !model) {
      return `${t(dealerType)} ${make}${cityHeaderVsSpace}`;
    }
    if (make && model && isAvto) {
      return `${make} ${model} в автосалонах${accusativeCityHeaderVsSpace}`;
    }
    return t(dealerType);
  }
  if (isBuss) {
    const dealerType = `${t('Автосалоны')} ${t('автобусов')}`;

    if (!make && !model && inGenitiveCityHeader) {
      return `${dealerType}${inGenitiveCityHeader}`;
    }
    if (make && !model && !cityHeader) {
      return `${t('Автобусы')} ${make} в автосалонах`;
    }
    if (make && !model && accusativeCityHeaderVsSpace) {
      return `${t('Автобусы')} ${make} в автосалонах${accusativeCityHeaderVsSpace}`;
    }

    return dealerType;
  }
  if (isTrucks) {
    const dealerType = `${t('Автосалоны грузовых автомобилей')}`;

    if (!make && !model && inGenitiveCityHeader) {
      return `${dealerType}${inGenitiveCityHeader}`;
    }
    if (make && !model && !cityHeader) {
      return `${t('Гррузовые')} ${make} в автосалонах`;
    }
    if (make && !model && accusativeCityHeaderVsSpace) {
      return `${t('Гррузовые')} ${make} в автосалонах${accusativeCityHeaderVsSpace}`;
    }
    return dealerType;
  }
  if (slug === 'spetstehnika') {
    if (make && !cityHeader) {
      return `${t('Дилеры')} ${t('спецтехники')} ${make}`;
    }
    if (!make && inGenitiveCityHeader) {
      return `${t('Дилеры')} ${t('спецтехники')}${inGenitiveCityHeader}`;
    }
    return `${t('Дилеры')} ${t('спецтехники')}`;
  }
  if (slug === 'vodnyi-transport') {
    if (make && !cityHeader) {
      return `${t('Водный транспорт')} ${make} – ${t('компании')}`;
    }
    if (!make && inGenitiveCityHeader) {
      return `${t('Водный транспорт')}${inGenitiveCityHeader} – ${t('компании')}`;
    }
    return `${t('Водный транспорт')} – ${t('компании')}`;
  }
  if (slug === 'pritsepy') {
    if (make && !cityHeader) {
      return `${t('Прицепы')} ${make} – ${t('каталог компаний')}`;
    }
    if (!make && inGenitiveCityHeader) {
      return `${t('Прицепы')} – ${t('каталог компаний')}${inGenitiveCityHeader}`;
    }
    return `${t('Прицепы')} – ${t('каталог компаний')}`;
  }

  return `${t('Автосалоны')}${inGenitiveCityHeader}`;
};

export const buildSparePartsSeoHeader = (data, rubricSlug, t, isRegion) => {
  const locale = t('locale');
  const {
    make,
    model,
    rubric: rubricTitle,
    partType: partTypeRu,
    partTypeUk,
    location,
    transport: selectedTransport,
  } = data;

  const seoData = getSeoDataByParams(data, t, 'zapchasti');
  if (seoData && seoData.header) return seoData.header;

  let rubric = rubricTitle;
  let partType = partTypeRu;
  const transport = replaceTransport(selectedTransport);

  let inCityOrRegion = `${t('в городе')} ${t(location)}`;
  if (isRegion && location) {
    inCityOrRegion = `в ${sity[location][locale].genitive}`;
  }

  if (locale === 'uk' && partTypeUk) partType = partTypeUk;

  if (!rubricSlug && !partType && !rubric) {
    if (!make && !model && !location) {
      return `${t('Запчасти')} на ${transport} ${t('в Украине')}`;
    }
    if (make && !model && !location) {
      return `${t('Запчасти')} на ${transport} ${make} ${t('в Украине')}`;
    }
    if (make && model && !location) {
      return `${t('Запчасти')} на ${make} ${model} ${t('в Украине')}`;
    }
    if (!model && location) {
      return `${t('Запчасти')}${valueVsTabOrEmpty(make)}${valueVsTabOrEmpty(
        model,
      )} на ${transport} ${inCityOrRegion}`;
    }
    if (make && model && location) {
      return `${t('Запчасти')} на ${make} ${model} в ${sity[location][locale].genitive}`;
    }
  }
  if (FIRST_RUBRICS_TYPES.includes(rubricSlug)) {
    rubric = rubric && rubrics[rubric][locale].accusative;
  } else if (SECOND_RUBRICS_TYPES.includes(rubricSlug)) {
    rubric = rubric && rubrics[rubric][locale].nominative;
  }

  /* ____________________FIRST TYPE VS RUBRIC_______________________ */

  if (rubricSlug && rubric && !partType && FIRST_RUBRICS_TYPES.includes(rubricSlug)) {
    if (!model && !location) {
      return `${t('Запчасти')} ${rubric} на ${transport}${valueVsTabOrEmpty(make)}`;
    }
    if (model && !location) {
      return `${t('Запчасти')} ${rubric} на${valueVsTabOrEmpty(make)}${valueVsTabOrEmpty(model)}`;
    }
    if (model && !location && locale === 'uk') {
      return `${t('Запчасти')} ${rubric}${locale === 'ru' ? ' на' : ''}${valueVsTabOrEmpty(
        make,
      )}${valueVsTabOrEmpty(model)}`;
    }

    if (!make && !model && location) {
      return `${t('Запчасти')} ${rubric} на ${transport} ${t(location)}`;
    }
    if (make && !model && location) {
      return `${t('Запчасти')} ${rubric} на ${transport}${valueVsTabOrEmpty(make)} ${t(location)}`;
    }
    if (make && model && location) {
      return `${t('Запчасти')} ${rubric}${valueVsTabOrEmpty(make)}${valueVsTabOrEmpty(model)} ${t(
        location,
      )}`;
    }
  }

  /* ____________________FIRST TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (rubricSlug && rubric && partType && FIRST_RUBRICS_TYPES.includes(rubricSlug)) {
    if (!make && !model) {
      return `${replaceToUpperCase(partType)} на ${transport}${valueVsTabOrEmpty(t(location))}`;
    }
    if (make && !location) {
      return `${replaceToUpperCase(partType)} ${make}${valueVsTabOrEmpty(model)}`;
    }

    if (make && location) {
      return `${t('Запчасти')} ${rubric} на ${transport} ${make}${valueVsTabOrEmpty(
        model,
      )} – ${partType} ${t(location)}`;
    }
  }

  /* ____________________SECOND TYPE VS RUBRIC_______________________ */

  if (rubricSlug && rubric && !partType && transport && SECOND_RUBRICS_TYPES.includes(rubricSlug)) {
    if (!model && !location) {
      return `${rubric} на ${transport}${valueVsTabOrEmpty(make)}`;
    }
    if (model && !location) {
      return `${rubric} на ${make} ${model}`;
    }

    if (location) {
      return `${rubric} на ${transport}${valueVsTabOrEmpty(make)}${valueVsTabOrEmpty(model)} ${t(
        location,
      )}`;
    }
  }

  /* ____________________SECOND TYPE VS RUBRIC && PART_TYPE_______________________ */

  if (rubricSlug && rubric && partType && SECOND_RUBRICS_TYPES.includes(rubricSlug)) {
    if (!make && !model) {
      return `${replaceToUpperCase(partType)} на ${transport}${valueVsTabOrEmpty(t(location))}`;
    }
    if (make && !model && !location) {
      return `${replaceToUpperCase(partType)} на ${make}`;
    }
    if (make && model && !location) {
      return `${replaceToUpperCase(partType)} ${make} ${model}`;
    }

    if (!model && location) {
      return `${replaceToUpperCase(partType)} на ${transport}${valueVsTabOrEmpty(make)} ${t(
        location,
      )}`;
    }

    if (make && model && location) {
      return `${replaceToUpperCase(partType)} на ${model} ${make} ${t(location)}`;
    }
  }

  return `${t('Запчасти')} на ${transport} ${t('в Украине')}`;
};

export const buildCommercialSeoHeader = (params, t) => {
  const data = params;

  const seoData = getSeoDataByParams(data, t, 'commercial');
  if (seoData && seoData.header) return seoData.header;

  if (data.cityHeader) {
    data.cityHeader = `${t(data.cityHeader) !== t('Украине') ? t('в') : 'в'} ${t(data.cityHeader)}`;
  } else data.cityHeader = `в ${t('Украине')}`;

  const { transportHeader, make, model, transportType, cityHeader, transportCategoryTitle } = data;

  const categoryTypes = {
    avtobus: 'Автобусы',
    moto: 'Мототехника',
  };

  if ((transportType === 'avtobus' || transportType === 'moto') && transportCategoryTitle) {
    return `${t(categoryTypes[transportType])} ${transportCategoryTitle} ${cityHeader}`;
  }

  if (
    (transportType === 'pritsepy' ||
      transportType === 'spetstehnika' ||
      transportType === 'vodnyi-transport') &&
    transportCategoryTitle
  ) {
    return `${transportCategoryTitle} ${cityHeader}`;
  }

  if (transportHeader && !make && !model) {
    return t('Продажа {transportHeader} {cityHeader}', {
      ...data,
      transportHeader: replaceToLowerCase(transportHeader),
    });
  }
  if (transportHeader && make && model) {
    return t('Купить {transportHeader} {make} {model} {cityHeader}', {
      ...data,
      transportHeader: replaceToLowerCase(transportHeader),
    });
  }
  if (transportHeader && make && !model) {
    if (transportType === 'avtobus') {
      return `${t('Автобусы')} ${make} ${cityHeader}`;
    }
    return t('Купить {transportHeader} {make} {cityHeader}', {
      ...data,
      transportHeader: replaceToLowerCase(transportHeader),
    });
  }
  return '';
};



// WEBPACK FOOTER //
// ./src/shared/helpers/seoHeaders.js